import cc from 'classcat';
import { useEvt } from 'evt/hooks';
import React, { CSSProperties, useEffect } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import C from './WorldCorridorPanel.css';

import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import CommunitySettingsTrigger from 'components/community-settings-trigger/CommunitySettingsTrigger';

import CocoJamIcon from '!!react-svg-loader!./icons/icon--coco-jam.svg';
import MediaLibraryIcon from '!!react-svg-loader!../community-overview-panel/icon--media-library.svg';
import RemixSpaceIcon from '!!react-svg-loader!./icons/icon--remix-space.svg';
import WorldCorridorThumbnail from '!!react-svg-loader!./icons/world-corridor-thumbnail.svg';

import ROUTES, { DashboardParams } from 'constants/routes';
import { visitSpaceSectionEvt } from 'utils/events/space';

import { getWorldCorridorSections } from 'atoms/spaces';
import { LightTooltip } from '../min-sidebar-community-list/MinSidebarCommunityList';
import { SpaceExplorerStateAtom } from '../space-explorer-panel/SpaceExplorerPanel';
import { Trans, msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const sectionIcons = {
  'coco-jams': CocoJamIcon,
  'spaces-to-remix': RemixSpaceIcon,
  'asset-packs': MediaLibraryIcon,
};

export default function WorldCorridorPanel(p: {
  className?: string;
  style?: CSSProperties;
}) {
  const { _ } = useLingui();
  const dashboardParams = useParams<DashboardParams>();
  const communityId = dashboardParams?.communityId;
  const [activeSectionId, setActiveSectionId] = useRecoilState(
    SpaceExplorerStateAtom,
  );

  const routeMatch = useRouteMatch();

  const isSpacesPage = routeMatch.path === ROUTES.COMMUNITY_DASHBOARD_SPACES;

  useEffect(() => {
    setActiveSectionId(getWorldCorridorSections()[0].id);
  }, []);

  useEvt((ctx) => {
    visitSpaceSectionEvt.attach(ctx, ({ sectionId }) => {
      console.log('visitSpaceSectionEvt', sectionId);
      setActiveSectionId(sectionId);
    });
  }, []);

  if (!communityId) return null;

  return (
    <div className={p.className} style={p.style}>
      <div className={C.thumbnail}>
        <WorldCorridorThumbnail />
      </div>
      <div className={C.detailsContainer}>
        <header className={C.primaryHeader}>
          {communityId && (
            <CommunitySettingsTrigger
              communityId={communityId}
              style={{ float: 'right' }}
            />
          )}
          <Trans>World Gallery</Trans>
        </header>
        <div style={{ color: 'var(--color-subtext)' }}>
          <Trans>
            Get ideas and inspiration from the CoCo Team and other creators
            around the world!
          </Trans>
        </div>
      </div>
      <List>
        {getWorldCorridorSections().map((section) => {
          const Icon = sectionIcons[section.id];
          return (
            <LightTooltip
              title={section.id === 'asset-packs' ? _(msg`Coming soon`) : ''}
              placement={'right'}
              arrow
              key={section.id}
            >
              <ListItem
                key={section.id}
                className={cc({
                  [C.navListItem]: true,
                  [C.active]: isSpacesPage && section.id === activeSectionId,
                })}
                onClick={async () => {
                  if (section.id === 'asset-packs') {
                    // history.push(`/app/dashboard/:communityId/media-lib`);
                    // await timeout(500);
                  } else {
                    visitSpaceSectionEvt.post({
                      sectionId: section.id,
                    });
                  }
                }}
              >
                {Icon && (
                  <ListItemIcon style={{ minWidth: '20px', cursor: 'pointer' }}>
                    <Avatar style={{ height: '30px', width: '30px' }}>
                      <Icon style={{ height: '16px', width: '16px' }} />
                    </Avatar>
                  </ListItemIcon>
                )}
                <ListItemText
                  style={{ paddingLeft: '10px', cursor: 'pointer' }}
                >
                  {section.altLabel}
                </ListItemText>
              </ListItem>
            </LightTooltip>
          );
        })}
      </List>
    </div>
  );
}
